

export const FETCH_ARCHIVE_REQUEST = 'FETCH_ARCHIVE_REQUEST';
export const FETCH_ARCHIVE_REQUEST_COMPLETED = 'FETCH_ARCHIVE_REQUEST_COMPLETED';
export const FETCH_ARCHIVE_REQUEST_ERROR = 'FETCH_ARCHIVE_REQUEST_ERROR';
export const FETCH_ARCHIVE_RESET = 'FETCH_ARCHIVE_RESET';

export const FETCH_ARCHIVE_LIST_REQUEST = 'FETCH_ARCHIVE_LIST_REQUEST';
export const FETCH_ARCHIVE_LIST_REQUEST_COMPLETED = 'FETCH_ARCHIVE_LIST_REQUEST_COMPLETED';
export const FETCH_ARCHIVE_LIST_REQUEST_ERROR = 'FETCH_ARCHIVE_LIST_REQUEST_ERROR';
export const FETCH_ARCHIVE_LIST_RESET = 'FETCH_ARCHIVE_LIST_RESET';

export const ADD_ARCHIVE_INITIAL = 'ADD_ARCHIVE_INITIAL';
export const ADD_ARCHIVE_REQUEST = 'ADD_ARCHIVE_REQUEST';
export const ADD_ARCHIVE_REQUEST_COMPLETED = 'ADD_ARCHIVE_REQUEST_COMPLETED';
export const ADD_ARCHIVE_REQUEST_ERROR = 'ADD_ARCHIVE_REQUEST_ERROR';


// WEBPACK FOOTER //
// ./constants/archivedetails.js